import "../components/plasmic/creditstorm_landing_app/plasmic.css"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/projectcss
import "@/styles/globals.css";
import "survey-core/survey-core.min.css";
import {LGRuntimeProvider, useRuntimeConfig} from "@lg-plus/landing-components";
import {GoogleTag} from "@lg-plus/landing-components/GoogleTag";
import {PlasmicRootProvider} from "@plasmicapp/react-web";
import type {AppProps} from "next/app";
import Head from "next/head";
import Link from "next/link";

export default function MyApp({Component, pageProps}: AppProps) {
    const config = useRuntimeConfig(pageProps);

    return (
        <PlasmicRootProvider Head={Head} Link={Link}>
            <Head>
                <meta name="format-detection" content="telephone=no" />
                <link rel="icon" href="/favicon.ico" sizes="any" />
                <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
                <link rel="manifest" href="/site.webmanifest" />
            </Head>
            <GoogleTag gtmId={config.gtmId} gtmCustomParams={config.gtmCustomParams} />
            <LGRuntimeProvider
                config={config}
                initialCommand={pageProps.initialCommand}
                initialFormData={pageProps.initialFormData}
                flashMessage={pageProps.flashMessage}
            >
                <Component {...pageProps} />
            </LGRuntimeProvider>
        </PlasmicRootProvider>
    );
}
